import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PageTabs from '../../ui/PageTabs';
import { t } from '../../utils/i18n';
import CommunityDataSourceToggle from '../../components/CommunityDataSourceToggle/CommunityDataSourceToggle';
import CommunityOverview from './CommunityOverview';
import CommunityThreads from './CommunityThreads';
import CommunityPlayground from './CommunityPlayground';
import CommunityNearby from './CommunityNearby';
import CommunityMapPage from './CommunityMapPage';
import CommunityReports from './CommunityReports';
import CommunityBoards from './CommunityBoards';

const basePath = '/community';

const tabs = [
  { path: basePath, labelKey: 'community.tabs.overview', descKey: 'community.tabs.overviewDesc' },
  { path: `${basePath}/threads`, labelKey: 'community.tabs.threads', descKey: 'community.tabs.threadsDesc' },
  { path: `${basePath}/boards`, labelKey: 'community.tabs.boards', descKey: 'community.tabs.boardsDesc' },
  { path: `${basePath}/playground`, labelKey: 'community.tabs.playground', descKey: 'community.tabs.playgroundDesc' },
  { path: `${basePath}/nearby`, labelKey: 'community.tabs.nearby', descKey: 'community.tabs.nearbyDesc' },
  { path: `${basePath}/map`, labelKey: 'community.tabs.map', descKey: 'community.tabs.mapDesc' },
  { path: `${basePath}/reports`, labelKey: 'community.tabs.reports', descKey: 'community.tabs.reportsDesc' },
];

export default function Community() {
  const location = useLocation();

  const activeTab =
    tabs.find((tab) =>
      tab.path === basePath
        ? location.pathname === basePath || location.pathname === `${basePath}/`
        : location.pathname.startsWith(tab.path),
    ) || tabs[0];

  const isQa = ['playground', 'nearby', 'map'].some(path => location.pathname === `${basePath}/${path}`);
  const visibleTabs = tabs.filter(tab => isQa === ['playground', 'nearby', 'map'].some(path => tab.path === `${basePath}/${path}`));

  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8 bg-dark-bg">
      <div className="max-w-[min(100%,1920px)] mx-auto">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-dark-text">
              {t(isQa ? 'adminUi.communityQa' : 'community.title')}
            </h1>
            <p className="text-dark-text-secondary text-sm mt-1 max-w-2xl">
              {t('community.description')}
            </p>
          </div>
          <CommunityDataSourceToggle />
        </div>

        <PageTabs label={t(isQa ? 'adminUi.communityQa' : 'community.title')} active={activeTab.path} items={visibleTabs.map(tab => ({ id: tab.path, to: tab.path, label: t(tab.labelKey) }))} />

        <p className="mt-3 text-xs text-dark-text-secondary">{t(activeTab.descKey)}</p>

        <div className="mt-6">
          <Routes>
            <Route index element={<CommunityOverview />} />
            <Route path="threads" element={<CommunityThreads />} />
            <Route path="boards" element={<CommunityBoards />} />
            <Route path="playground" element={<CommunityPlayground />} />
            <Route path="nearby" element={<CommunityNearby />} />
            <Route path="map" element={<CommunityMapPage />} />
            <Route path="reports" element={<CommunityReports />} />
            <Route path="*" element={<Navigate to={basePath} replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
